<ng-template #loading>
  Loading report...
</ng-template>

<ng-container *ngIf="(loadplanningService.loadPlanning$ | async) as planning;">
  <mat-card>
    <mat-card-header>
      <div class="mat-card-header-text">{{ 'LOADPLANNING.TITLE_MORE_INFO_DIALOG' | translate }}</div>
      <div>
        <button mat-icon-button aria-label="Close dialog" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-card-header>
    <ng-container *ngIf="planning.status === 'optimal'; else infeasible">
      <mat-card-content>
        <section *ngIf="shoppingCartService.itemsTotalsChanged | async as totals" class="columns">
          <div class="block">
            <p>{{ totals?.volume || '-' }} {{ 'UNITS.VOLUME_METERS_CUBE' | translate }}</p>
            <p>{{ totals?.weight || '-' }} {{ 'UNITS.WEIGHT_KILOGRAMS' | translate }}</p>
            <div class="block">
              <span class="super">{{ 'LOADPLANNING.AVAILABLE_SIZE' | translate }}</span>
              <p>{{ planning?.extras?.nextSize || '-' }}</p>
            </div>
          </div>
          <div class="last" fxHide fxShow.gt-xs style="transform: scale(2.5)">
            <app-truck></app-truck>
          </div>
          <div class="last" fxShow fxHide.gt-xs style="transform: scale(1.5)">
            <app-truck></app-truck>
          </div>
        </section>

        <section>
          <h3 class="padding">{{ 'LOADPLANNING.TITLE_PLAN' | translate }}
            <!-- <mat-icon title="{{ planning?.report }}" style="cursor: help">info</mat-icon> -->
          </h3>
          <div class="table">
            <div class="row" *ngFor="let row of (planningTable$ | async)">
              <div class="column" *ngFor="let col of row" [class.selected]="col.selected" [class.empty]="col.empty">
                {{ col.value }}
              </div>
            </div>
          </div>
        </section>

        <section class="details">
          <!-- <h3>{{ 'LOADPLANNING.TITLE_DETAILS' | translate }}</h3> -->
          <ng-container *ngIf="planning?.extras as extras">
            <ng-container *ngIf="extras; else loading">
              <h3>{{ extras?.selected }}</h3>
              <div class="sub-header">
                <span class="bold grey">{{ extras?.next[0] | slice:2}}</span>
                <span class="bold">{{ extras?.next[1] }}</span>
              </div>
              <div class="list grey">
                <div class="left grey">
                  <p *ngFor="let row of extras?.details"> <span>{{ row[0] | slice:2 }}</span></p>
                </div>
                <div class="right">
                  <p *ngFor="let row of extras?.details"> <span>{{ row[1] }}</span> </p>
                </div>
              </div>

            </ng-container>
          </ng-container>
        </section>


      </mat-card-content>
    </ng-container>

    <ng-template #infeasible>
      <mat-card-content>
        <section *ngIf="shoppingCartService.itemsTotalsChanged | async as totals" class="columns">
          <div class="block">
            <p>{{ totals?.volume || '-' }} {{ 'UNITS.VOLUME_METERS_CUBE' | translate }}</p>
            <p>{{ totals?.weight || '-' }} {{ 'UNITS.WEIGHT_KILOGRAMS' | translate }}</p>
            <div class="block">
              <span class="super">{{ 'LOADPLANNING.AVAILABLE_SIZE' | translate }}</span>
              <p>{{ planning?.extras?.nextSize || '-' }}</p>
            </div>
          </div>
          <div class="last" style="transform: scale(1.7)">
            <app-truck></app-truck>
          </div>
        </section>
      </mat-card-content>
    </ng-template>
  </mat-card>

</ng-container>
